/* @flow */

import React from 'react'
import { connect } from 'react-redux'

import type { RootState, Dispatch } from '../types'

import { selectError, unsetError } from '../stores/error'

type Props = {
  error: ?Error,
  unsetError: () => void,
}

type StateProps = {
  error: ?Error,
}

type DispatchProps = $Diff<Props, StateProps>

function ErrorModal(props: Props) {
  if (props.error == null) {
    return null
  }

  return (
    <div className="modal in" style={{ display: 'block' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={props.unsetError}>
              <span>&times;</span>
            </button>
            <h4 className="modal-title">An Error occurred</h4>
          </div>
          <div className="modal-body">
            <h5>{props.error.name}</h5>
            <pre>{props.error.message}</pre>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              onClick={props.unsetError}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state: RootState): StateProps {
  return {
    error: selectError(state),
  }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
  return {
    unsetError() {
      dispatch(unsetError())
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorModal)



// WEBPACK FOOTER //
// ./src/components/ErrorModal.js